"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("./SvgIcon"));
const AppleLogo = (_a) => {
    var { size } = _a, rest = __rest(_a, ["size"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SvgIcon_1.default, Object.assign({ "data-icon": "apple-logo", size: size, viewBox: "0 0 22.773 22.773", xmlns: "http://www.w3.org/2000/svg" }, rest),
            react_1.default.createElement("g", null,
                react_1.default.createElement("g", null,
                    react_1.default.createElement("path", { d: "M15.769,0c0.053,0,0.106,0,0.162,0c0.13,1.606-0.483,2.806-1.228,3.675c-0.731,0.863-1.732,1.7-3.351,1.573\n\t\t\tc-0.108-1.583,0.506-2.694,1.25-3.561C13.292,0.879,14.557,0.16,15.769,0z" }),
                    react_1.default.createElement("path", { d: "M20.67,16.716c0,0.016,0,0.03,0,0.045c-0.455,1.378-1.104,2.559-1.896,3.655c-0.723,0.995-1.609,2.334-3.191,2.334\n\t\t\tc-1.367,0-2.275-0.879-3.676-0.903c-1.482-0.024-2.297,0.735-3.652,0.926c-0.155,0-0.31,0-0.462,0\n\t\t\tc-0.995-0.144-1.798-0.932-2.383-1.642c-1.725-2.098-3.058-4.808-3.306-8.276c0-0.34,0-0.679,0-1.019\n\t\t\tc0.105-2.482,1.311-4.5,2.914-5.478c0.846-0.52,2.009-0.963,3.304-0.765c0.555,0.086,1.122,0.276,1.619,0.464\n\t\t\tc0.471,0.181,1.06,0.502,1.618,0.485c0.378-0.011,0.754-0.208,1.135-0.347c1.116-0.403,2.21-0.865,3.652-0.648\n\t\t\tc1.733,0.262,2.963,1.032,3.723,2.22c-1.466,0.933-2.625,2.339-2.427,4.74C17.818,14.688,19.086,15.964,20.67,16.716z" })),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null),
                react_1.default.createElement("g", null)),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null),
            react_1.default.createElement("g", null))));
};
exports.default = AppleLogo;
//# sourceMappingURL=AppleLogo.js.map